// test352
(352 && 0);
